<div class="p-6 pt-4">
    <h3 class="text-xl font-bold mb-2 text-shs-white-1 flex items-center gap-2">Reassign COD</h3>
    <p class="text-base text-shs-white-1 mb-4">Select a person you want to assign this COD to.</p>
    @if (assignableUsersLoading()) {
    <div class="animate-pulse h-[42px] w-full bg-[#333333] rounded-md"></div>
    } @else {
    <sag-ui-autocomplete [formControl]="formControl">
        @for (user of assignableUsers(); track $index) {
        <sag-ui-autocomplete-option [value]="user.gid"
            >{{ user.firstName }} {{ user.lastName }} ({{ user.gid }})</sag-ui-autocomplete-option
        >
        }
    </sag-ui-autocomplete>
    }
    <div class="flex justify-end items-center gap-2 mt-8">
        <sag-ui-button color="secondary" size="sm" (click)="onClose()">Cancel</sag-ui-button>
        <sag-ui-button size="sm" (click)="onClose('reassign')" [disabled]="invalid">Reassign</sag-ui-button>
    </div>
</div>
